import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';

const testimonials = [
  {
    name: "Sarah Johnson",
    role: "Small Business Owner",
    content: "The Bitcoin ATM has been a game-changer for my cafe. It attracts new customers daily and the support team is incredible!",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=150&h=150"
  },
  {
    name: "Michael Chen",
    role: "Crypto Enthusiast",
    content: "The easiest way to buy Bitcoin. The interface is simple and the verification process is quick. Highly recommended!",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=150&h=150"
  },
  {
    name: "David Smith",
    role: "BTM User",
    content: "I appreciate the straightforward fees and quick transactions. Much better than waiting days for exchange transfers.",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=150&h=150"
  }
];

export default function Testimonials() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const next = () => setCurrent((prev) => (prev + 1) % testimonials.length);
  const prev = () => setCurrent((prev) => (prev - 1 + testimonials.length) % testimonials.length);

  return (
    <div className="relative bg-gray-800/50 backdrop-blur-sm rounded-lg p-8">
      <Quote className="absolute text-purple-500/20 w-24 h-24 -top-4 -left-4" />
      <div className="relative">
        <div className="flex items-center">
          <img
            src={testimonials[current].image}
            alt={testimonials[current].name}
            className="w-16 h-16 rounded-full object-cover mr-4"
          />
          <div>
            <h3 className="text-xl font-semibold text-white">{testimonials[current].name}</h3>
            <p className="text-purple-400">{testimonials[current].role}</p>
          </div>
        </div>
        <p className="mt-4 text-gray-300 italic">{testimonials[current].content}</p>
        <div className="flex justify-between mt-6">
          <button
            onClick={prev}
            className="p-2 rounded-full bg-gray-700 hover:bg-gray-600 transition-colors"
          >
            <ChevronLeft className="w-5 h-5 text-white" />
          </button>
          <button
            onClick={next}
            className="p-2 rounded-full bg-gray-700 hover:bg-gray-600 transition-colors"
          >
            <ChevronRight className="w-5 h-5 text-white" />
          </button>
        </div>
      </div>
    </div>
  );
}